// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__33XUy","row":"ProcedureTreatmentSummary_row__24VOi"};